import { render, staticRenderFns } from "./CourseUpdate.vue?vue&type=template&id=35d1d221&scoped=true&"
import script from "./CourseUpdate.vue?vue&type=script&lang=js&"
export * from "./CourseUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CourseUpdate.vue?vue&type=style&index=0&id=35d1d221&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d1d221",
  null
  
)

export default component.exports